import findNearestDatumSingleDimension from "./findNearestDatumSingleDimension.js";
export default function findNearestDatumY(_ref) {
  let {
    yScale: scale,
    yAccessor: accessor,
    xScale,
    xAccessor,
    point,
    data
  } = _ref;
  if (!point) return null;
  const nearestDatum = findNearestDatumSingleDimension({
    scale,
    accessor,
    scaledValue: point.y,
    data
  });
  return nearestDatum ? {
    datum: nearestDatum.datum,
    index: nearestDatum.index,
    distanceY: nearestDatum.distance,
    distanceX: Math.abs(Number(xScale(xAccessor(nearestDatum.datum))) - point.x)
  } : null;
}